import { Component } from 'react';
import IconFacebook from '../assets/ic_facebook.svg';
import IconTwitter from '../assets/ic_twitter.svg';
import IconInstagram from '../assets/ic_instagram.svg';
//import FooterImage from '../assets/footer_image.svg';

import { clientSettings, executeGet, createNewHeaders, updateHeaders } from '../functions/Kubuku';
import { LIST_KATEOGRI } from '../api';

const noTelepon = localStorage.getItem("nomorTelepon")
const email = localStorage.getItem("email") 
const domain = localStorage.getItem("domain") 
const LogoHeader = clientSettings.logo
const FooterImage = localStorage.getItem("payLogo");
const alamat = localStorage.getItem("alamat");
const jam = localStorage.getItem("footer");
const aJam = (jam + "<br>").split("<br>");
class Footer extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      path: window.location.pathname,
      dataTemp: [],
      data: []
    }

  }

  componentDidMount = () => {
    //this.getListKategori();
  }

  getListKategori = async () => {
    try {
      const flagOpen = localStorage.getItem('flagOpen');
      console.log("flagOpen = " + flagOpen);
      if(flagOpen != "1") {
      createNewHeaders('', ''); 
      } else {
      updateHeaders('', ''); 
      }
      const json = await executeGet(LIST_KATEOGRI);
      // console.log("list_kategori = " + JSON.stringify(json));
      if (json.code == 200) {
        this.setState({
          dataTemp: json.data[0]
        }, () => {
          // console.log("getListKategori = " + JSON.stringify(this.state.dataTemp)); 
          let randomVal = [];
          for(let i=0; i<7; i++) {
            const random = this.state.dataTemp[Math.floor(Math.random() * this.state.dataTemp.length)];
            randomVal.push(random);
            // this.state.data.push(random);
          }
          this.setState({
            data: randomVal
          })
          // console.log("getListKategori_random = " + JSON.stringify(this.state.data)); 
        });
      }
    } catch (error) {
      //console.log(error);
      // this.setState({ isLoading: false, isError: true, msg: "Network Error!" });
    }

  }

  render() {
    return (
      <div>
        <footer className="hidden lg:block">
          {
            this.state.path != '/login' && this.state.path != '/register' && this.state.path != '/resetPassword' && this.state.path.substring(0, 26) != '/resetPasswordConfirmation' &&
            <div>
              <footer className="px-8 xl:px-28 footer py-10 bg-white text-base-content border-t-4 border-greenWalang">
                <div>
                  {/* <svg width="50" height="50" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" className="fill-current"><path d="M22.672 15.226l-2.432.811.841 2.515c.33 1.019-.209 2.127-1.23 2.456-1.15.325-2.148-.321-2.463-1.226l-.84-2.518-5.013 1.677.84 2.517c.391 1.203-.434 2.542-1.831 2.542-.88 0-1.601-.564-1.86-1.314l-.842-2.516-2.431.809c-1.135.328-2.145-.317-2.463-1.229-.329-1.018.211-2.127 1.231-2.456l2.432-.809-1.621-4.823-2.432.808c-1.355.384-2.558-.59-2.558-1.839 0-.817.509-1.582 1.327-1.846l2.433-.809-.842-2.515c-.33-1.02.211-2.129 1.232-2.458 1.02-.329 2.13.209 2.461 1.229l.842 2.515 5.011-1.677-.839-2.517c-.403-1.238.484-2.553 1.843-2.553.819 0 1.585.509 1.85 1.326l.841 2.517 2.431-.81c1.02-.33 2.131.211 2.461 1.229.332 1.018-.21 2.126-1.23 2.456l-2.433.809 1.622 4.823 2.433-.809c1.242-.401 2.557.484 2.557 1.838 0 .819-.51 1.583-1.328 1.847m-8.992-6.428l-5.01 1.675 1.619 4.828 5.011-1.674-1.62-4.829z"></path></svg> */}
                  <img className='w-full' src={LogoHeader} alt="" style={{maxWidth:"240px"}} />

                  <p className="mt-2 dark: text-black">{alamat}</p>

                  <div className="flex space-x-6 mt-6">
                    <img className='w-full' src={IconFacebook} alt="" />
                    <img className='w-full' src={IconTwitter} alt="" />
                    <img className='w-full' src={IconInstagram} alt="" />

                  </div>
                </div>
                <div>
                  <span className="footer-title dark: text-black">Butuh Bantuan</span>
                  <a className="text-greenWalang text-[20px]">{noTelepon}</a>
                  <div className="text-[#999999] text-[13px] mt-8">
                    {aJam[0]}<br/>{aJam[1]}
                  </div>

                  <div className="text-[#878787] text-[20px] mt-4">
                    {email}
                  </div>
                </div>
                <div>
                  {/*
                  <span className="footer-title dark: text-black">Download</span>
                  <a className="text-[#999999] flex justify-center items-center space-x-2">
                    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M15.7107 1.37734C15.7012 1.15855 15.5966 0.954848 15.4242 0.819718C15.2519 0.684589 15.0291 0.631533 14.8144 0.674482C14.3141 0.77454 12.6824 1.1796 11.3941 2.46782C10.7363 3.12562 10.3722 3.956 10.1749 4.71195C10.0733 5.10154 10.0125 5.48411 9.98023 5.8344C9.90336 5.80097 9.82267 5.76602 9.73713 5.72955C9.04417 5.43409 8.1478 5.08909 7.12768 5.08909C6.03502 5.08909 4.48455 5.53363 3.20451 6.78991C1.90674 8.06357 0.949955 10.1078 0.949951 13.1904C0.949949 14.9223 1.81606 17.4409 2.98341 19.4848C3.57364 20.5182 4.26846 21.4801 5.01845 22.1888C5.74685 22.8771 6.63527 23.4271 7.60294 23.4022C8.32315 23.3992 9.05214 23.1165 9.62025 22.8961L9.67039 22.8767C10.3239 22.6235 10.7899 22.4525 11.181 22.4525C11.555 22.4525 12.0245 22.6232 12.6891 22.8777L12.7377 22.8963C13.3144 23.1174 14.057 23.4022 14.7703 23.4022C15.3089 23.4022 15.9324 23.1141 16.4782 22.7746C17.0616 22.4118 17.6927 21.9032 18.274 21.2993C19.4115 20.1174 20.4906 18.428 20.4488 16.6201C20.4422 16.3369 20.2767 16.0816 20.0208 15.96C19.6739 15.7952 19.1078 15.4228 18.6307 14.8756C18.1577 14.3333 17.8091 13.6641 17.7873 12.888C17.7566 11.7925 18.0641 10.8237 18.4703 10.0815C18.8915 9.31199 19.3695 8.87106 19.5919 8.75452C19.7839 8.6539 19.923 8.47515 19.9733 8.26431C20.0236 8.05347 19.9802 7.83118 19.8544 7.65471C19.5117 7.17425 18.8623 6.54287 18.0963 6.03364C17.3386 5.52985 16.3524 5.06894 15.3417 5.08924C15.1653 5.09278 14.9922 5.10578 14.8229 5.12636C15.1928 4.57657 15.4076 3.8945 15.5335 3.29577C15.6851 2.57455 15.7315 1.8559 15.7107 1.37734ZM12.4548 3.52848C12.9964 2.98691 13.6321 2.64484 14.1585 2.43408C14.1356 2.6127 14.1051 2.7994 14.0656 2.98714C13.9349 3.60892 13.7294 4.12902 13.4758 4.42482C12.9969 4.98361 12.3525 5.59354 11.4882 5.83471C11.5157 5.59791 11.5599 5.34532 11.6263 5.09069C11.7815 4.49584 12.0456 3.9377 12.4548 3.52848ZM15.3719 6.58894C15.937 6.57758 16.6141 6.84946 17.2659 7.28276C17.6096 7.51129 17.9141 7.76326 18.1564 7.99492C17.7988 8.35343 17.4484 8.82425 17.1545 9.36133C16.6415 10.2986 16.2486 11.5283 16.2879 12.9301C16.3222 14.1519 16.8724 15.1416 17.5002 15.8615C17.9596 16.3884 18.4805 16.7946 18.9295 17.0701C18.8035 18.1661 18.1063 19.3105 17.1933 20.2591C16.6912 20.7807 16.1558 21.2087 15.6859 21.5009C15.1784 21.8166 14.862 21.9022 14.7703 21.9022C14.3695 21.9022 13.8822 21.7284 13.2256 21.477L13.1461 21.4464C12.5817 21.2297 11.8601 20.9525 11.181 20.9525C10.4817 20.9525 9.76279 21.2317 9.20053 21.45L9.12849 21.478C8.48077 21.7289 8.002 21.9022 7.59166 21.9022C7.58406 21.9022 7.57645 21.9023 7.56885 21.9025C7.19281 21.914 6.67485 21.6903 6.04867 21.0986C5.44117 20.5245 4.83159 19.6962 4.28593 18.7409C3.18152 16.8072 2.44995 14.5539 2.44995 13.1904C2.44996 10.4342 3.29506 8.80275 4.25518 7.86046C5.23302 6.90078 6.39641 6.58909 7.12768 6.58909C7.82343 6.58909 8.48063 6.82446 9.14881 7.10936C9.23621 7.14663 9.32684 7.18609 9.41886 7.22616C9.65612 7.32947 9.90259 7.4368 10.1265 7.52074C10.4386 7.63772 10.8059 7.74983 11.181 7.74983C11.556 7.74983 11.9272 7.64471 12.2504 7.53068C12.4922 7.44536 12.7556 7.33644 13.0104 7.23108C13.0958 7.19577 13.1803 7.16085 13.2626 7.12737C13.9561 6.84525 14.6448 6.60354 15.3719 6.58894Z" fill="#999999" />
                    </svg>
                    <div>
                      IOS
                    </div>
                  </a>
          */}
                  
                  <span className="footer-title dark: text-black">Bookubuku</span>
                  <a href="/reader-bookubuku-electron-win32-x64.zip" className="text-[#999999] flex justify-center items-center space-x-2">
                  <img width="20" src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Windows_logo_-_2012.svg/88px-Windows_logo_-_2012.svg.png"/>
                    <div>
                      Windows
                    </div>
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=app.bookubuku.id" className="text-[#999999] flex justify-center items-center space-x-2">
                    
                    <svg width="20" height="24" viewBox="0 0 20 24" fill="green" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.1154 4.66668C9.1154 5.134 8.73657 5.51283 8.26925 5.51283C7.80193 5.51283 7.4231 5.134 7.4231 4.66668C7.4231 4.19936 7.80193 3.82053 8.26925 3.82053C8.73657 3.82053 9.1154 4.19936 9.1154 4.66668Z" fill="#999999" />
                      <path d="M11.6539 5.51283C12.1212 5.51283 12.5 5.134 12.5 4.66668C12.5 4.19936 12.1212 3.82053 11.6539 3.82053C11.1866 3.82053 10.8077 4.19936 10.8077 4.66668C10.8077 5.134 11.1866 5.51283 11.6539 5.51283Z" fill="#999999" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M4.35431 0.46967C4.64721 0.176777 5.12208 0.176777 5.41497 0.46967L6.64273 1.69742C7.5836 1.13641 8.68333 0.814117 9.85833 0.814117H10.0647C11.2397 0.814117 12.3395 1.13642 13.2803 1.69744L14.5081 0.46967C14.801 0.176777 15.2759 0.176777 15.5688 0.46967C15.8617 0.762563 15.8617 1.23744 15.5688 1.53033L14.477 2.62213C15.5154 3.645 16.1999 5.02619 16.33 6.56528C16.5446 6.49383 16.7742 6.45514 17.0128 6.45514C18.2059 6.45514 19.1731 7.42232 19.1731 8.61539V13.6923C19.1731 14.8854 18.2059 15.8526 17.0128 15.8526C16.7825 15.8526 16.5607 15.8165 16.3525 15.7498V17.6154C16.3525 18.5277 15.9083 19.3362 15.2243 19.8365V21.3077C15.2243 22.6565 14.1309 23.75 12.782 23.75C11.4332 23.75 10.3397 22.6565 10.3397 21.3077V20.3654H9.58335V21.3077C9.58335 22.6565 8.48989 23.75 7.14104 23.75C5.79219 23.75 4.69873 22.6565 4.69873 21.3077V19.8365C4.01475 19.3363 3.5705 18.5277 3.5705 17.6154V15.7498C3.36238 15.8165 3.14053 15.8526 2.91026 15.8526C1.71718 15.8526 0.75 14.8854 0.75 13.6923V8.6154C0.75 7.42232 1.71718 6.45514 2.91026 6.45514C3.14888 6.45514 3.37846 6.49383 3.59308 6.56528C3.72317 5.02617 4.40765 3.64497 5.44609 2.62211L4.35431 1.53033C4.06142 1.23744 4.06142 0.762563 4.35431 0.46967ZM5.3191 7.95514C5.18167 7.95589 5.0705 8.06753 5.0705 8.20514V8.60669L5.07051 8.61539V13.6923L5.0705 13.701V17.6154C5.0705 18.3043 5.62776 18.863 6.31608 18.8654H13.607C14.2953 18.863 14.8525 18.3043 14.8525 17.6154V13.6981L14.8525 13.6923V8.6154L14.8525 8.60959V8.20514C14.8525 8.06753 14.7414 7.95589 14.6039 7.95514H5.3191ZM14.6062 6.45514H14.8092C14.4934 4.1168 12.4896 2.31412 10.0647 2.31412H9.85833C7.43344 2.31412 5.4296 4.1168 5.11381 6.45514H5.3168L5.3205 6.45514H14.6025L14.6062 6.45514ZM11.8397 21.3077V20.3654L13.6025 20.3654L13.6091 20.3654H13.7243V21.3077C13.7243 21.8281 13.3025 22.25 12.782 22.25C12.2616 22.25 11.8397 21.8281 11.8397 21.3077ZM6.31395 20.3654L6.3205 20.3654L8.08335 20.3654V21.3077C8.08335 21.8281 7.66146 22.25 7.14104 22.25C6.62062 22.25 6.19873 21.8281 6.19873 21.3077V20.3654H6.31395ZM17.0128 14.3526C16.6492 14.3526 16.3543 14.0587 16.3525 13.6955V8.61219C16.3543 8.24901 16.6492 7.95514 17.0128 7.95514C17.3774 7.95514 17.6731 8.25075 17.6731 8.61539V13.6923C17.6731 14.057 17.3774 14.3526 17.0128 14.3526ZM3.5705 8.61058C3.56791 8.24815 3.2733 7.95514 2.91026 7.95514C2.54561 7.95514 2.25 8.25075 2.25 8.6154V13.6923C2.25 14.057 2.54561 14.3526 2.91026 14.3526C3.2733 14.3526 3.56791 14.0596 3.5705 13.6971V8.61058Z" fill="#999999" />
                    </svg>
                    <div>
                      Android
                    </div>
                  </a>
                </div>
                <div>
                  <span className="footer-title dark: text-black">Tentang Aplikasi</span>
                  <a href="/about" className="text-[#999999]">Tentang Kami</a>
                  <a href="/login" className="text-[#999999]">Masuk</a>
                  {/*<a href="/faq" className="text-[#999999]">FAQ</a>*/}
                  <a href="/help" className="text-[#999999]">Bantuan</a>
                  <a href="/privacypolicy" className="text-[#999999]">Kebijakan Privasi</a>
                  <a href="/termscondition" className="text-[#999999]">Syarat dan Ketentuan</a>
                </div>
                {/* 
                {alert(this.state.dataTemp.length)}
                {this.state.dataTemp.length>0 && 
                <div className="w-[40%]">
                  <span className="footer-title dark: text-black">Categories</span>
                  {
                    
                    this.state.dataTemp.slice(0, 5).map(item => {
                      return (
                        <a href={"/categorieDetail/" + item.id_kategori} className="text-[#999999] line-clamp-1">{item.kategori}</a>
                      )
                    })
                  }
                  <a href={"/categories"} className="text-[#999999] line-clamp-1">Selengkapnya</a>
                  
                </div>
                }
                */}
              </footer>
              <footer className="footer py-7 border-t dark: border-gray bg-white text-base-content border-base-300 px-36 items-center">
                <div className="items-center grid-flow-col">
                  <p>Copyright © 2022 <a className="text-greenWalang">{domain}</a> All rights reserved.</p>
                </div>
                <div className="lg:place-self-center lg:justify-self-end">
                  <img className='w-full' src={FooterImage} alt="" />
                </div>
              </footer>

            </div>
          }
        </footer>

        {/* <div className="block lg:hidden">
          <div className="flex items-center flex-wrap bg-white p-6 fixed w-full z-10 bottom-0 lg:px-24 border-t border-grayWalang shadow-md bg-[#ffffff]">
            Menu
          </div>

        </div> */}
      </div>

    );

  }
}

export default Footer;
